import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling';
import { useNavigate } from 'react-router-dom';
import generateCaptcha from '../../components/captcha';
import { FaFacebookSquare } from 'react-icons/fa';
import { MdOutlineInstallMobile, MdTextDecrease } from 'react-icons/md';
import { SiGoogleads, SiGoogleadsense, SiRazorpay } from 'react-icons/si';
import { FiSearch, FiPhone, FiUser, FiMapPin, FiMail, FiCreditCard, FiUsers, FiGlobe, FiShare2, FiSettings, FiHash, FiChevronRight, FiSave, FiToggleLeft, FiToggleRight } from 'react-icons/fi';
import { PiHandCoinsFill } from "react-icons/pi";

// Reusable Toggle Switch Component
const ToggleSwitch = ({ checked, onChange, size = 'default' }) => {
  const sizeClasses = size === 'small' ? 'w-10 h-5' : 'w-12 h-6';
  const dotSize = size === 'small' ? 'h-4 w-4' : 'h-5 w-5';
  const translateClass = size === 'small' ? 'translate-x-5' : 'translate-x-6';

  return (
    <button
      type="button"
      onClick={onChange}
      className={`${sizeClasses} relative rounded-full transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-main-blue/30 focus:ring-offset-2 ${checked
        ? 'bg-gradient-to-r from-main-blue to-blue-500'
        : 'bg-gray-200'
        }`}
    >
      <span
        className={`absolute top-0.5 left-0.5 ${dotSize} rounded-full bg-white shadow-md transform transition-transform duration-300 ease-out ${checked ? translateClass : 'translate-x-0'
          }`}
      />
    </button>
  );
};

// Section Header Component
const SectionHeader = ({ icon, title, action }) => (
  <div className="flex items-center justify-between pb-4 border-b border-gray-100">
    <div className="flex items-center gap-3">
      <div className="p-2.5 rounded-xl bg-gradient-to-br from-main-blue/10 to-main-blue/5 text-main-blue">
        {icon}
      </div>
      <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    </div>
    {action}
  </div>
);

// Setting Card Component
const SettingCard = ({ icon, label, description, children, highlighted = false }) => (
  <div className={`group p-4 rounded-2xl border transition-all duration-200 hover:shadow-sm ${highlighted
    ? 'border-main-blue/30 bg-gradient-to-br from-main-blue/5 to-transparent'
    : 'border-gray-100 bg-white hover:border-gray-200'
    }`}>
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <div className={`p-2 rounded-lg shrink-0 transition-colors ${highlighted
          ? 'bg-main-blue/10 text-main-blue'
          : 'bg-gray-100 text-gray-500 group-hover:bg-gray-200'
          }`}>
          {icon}
        </div>
        <div className="min-w-0">
          <h3 className="font-medium text-gray-800 text-sm">{label}</h3>
          {description && (
            <p className="text-xs text-gray-400 mt-0.5 truncate">{description}</p>
          )}
        </div>
      </div>
      <div className="shrink-0">
        {children}
      </div>
    </div>
  </div>
);

// Input with Save Button Component
const InputWithSave = ({ value, onChange, onSave, placeholder, type = 'text', min }) => (
  <div className="flex items-center gap-2">
    <input
      type={type}
      value={value}
      onChange={onChange}
      min={min}
      placeholder={placeholder}
      className="w-28 px-3 py-2 text-sm border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
    />
    <button
      onClick={onSave}
      className="p-2 rounded-xl bg-main-blue text-white hover:bg-main-blue/90 transition-colors"
    >
      <FiSave size={16} />
    </button>
  </div>
);

// Select Dropdown Component
const SelectDropdown = ({ value, onChange, options }) => (
  <div className="flex items-center gap-2">
    <select
      value={value}
      onChange={onChange}
      className="px-3 py-2 text-sm border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all min-w-[140px] cursor-pointer"
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
    <span className={`px-2.5 py-1 rounded-lg text-xs font-medium ${value === 'OFF'
      ? 'bg-gray-100 text-gray-500'
      : 'bg-green-50 text-green-600'
      }`}>
      {value === 'OFF' ? 'Off' : 'On'}
    </span>
  </div>
);

const Controler = () => {
  const [loader, setLoader] = useState(false);

  const [facebook_app_id, setFacebook_app_id] = useState('');
  const [facebook_client_token, setFacebook_client_token] = useState('');

  const [app_version, setApp_version] = useState('');
  const [inHouseAds, setInHouseAds] = useState(false);
  const [show_word, setShow_word] = useState('');

  const [ref_plan_status, setRef_plan_status] = useState(false);

  // Razorpay Settings
  const [razorpay_id, setRazorpay_id] = useState('');
  const [plan_status, setPlan_status] = useState(false);
  const [search_limit, setSearch_limit] = useState(10);
  const [masking_search, setMasking_search] = useState(10);
  const [masking_dailog, setMasking_dailog] = useState(10);

  // User Search Settings
  const [search_mobile, setSearch_mobile] = useState(true);
  const [search_name, setSearch_name] = useState(true);
  const [search_fname, setSearch_fname] = useState(true);
  const [search_address, setSearch_address] = useState(true);
  const [search_alt_mobile, setSearch_alt_mobile] = useState(true);
  const [search_circle, setSearch_circle] = useState(true);
  const [search_id_number, setSearch_id_number] = useState(true);
  const [search_email, setSearch_email] = useState(true);
  const [search_sub_name, setSearch_sub_name] = useState(true);
  const [search_btn_ads, setSearch_btn_ads] = useState('FS');
  const [search_module_status, setSearch_module_status] = useState(true);
  const [recant_btn_ads, setRecant_btn_ads] = useState('FS');

  // iOS Settings
  const [search_btn_ads_ios, setSearch_btn_ads_ios] = useState('FS');
  const [search_module_status_ios, setSearch_module_status_ios] = useState(true);
  const [intro_number_ios, setIntro_number_ios] = useState(1);
  const [welcome_btn_ads_ios, setWelcome_btn_ads_ios] = useState('FS');
  const [ios_shear_url, setIos_shear_url] = useState('');
  const [recant_btn_ads_ios, setRecant_btn_ads_ios] = useState('FS');

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);
    try {
      const resp = await Calling.getControleData();
      const { status, message, data } = resp;
      if (status) {
        setFacebook_app_id(data?.facebook_app_id || '');
        setFacebook_client_token(data?.facebook_client_token || '');
        setApp_version(data?.app_version || '');
        setInHouseAds(data?.inHouseAds || false);
        setShow_word(data?.show_word || '');

        // Razorpay Settings
        setRazorpay_id(data?.razorpay_id || '');
        setPlan_status(data?.plan_status ?? false);
        setSearch_limit(data?.search_limit || 10);
        setMasking_search(data?.masking_search || 10);
        setMasking_dailog(data?.masking_dailog || 10);

        // User Search Settings
        setSearch_mobile(data?.search_mobile ?? true);
        setSearch_name(data?.search_name ?? true);
        setSearch_fname(data?.search_fname ?? true);
        setSearch_address(data?.search_address ?? true);
        setSearch_alt_mobile(data?.search_alt_mobile ?? true);
        setSearch_circle(data?.search_circle ?? true);
        setSearch_id_number(data?.search_id_number ?? true);
        setSearch_email(data?.search_email ?? true);
        setSearch_sub_name(data?.search_sub_name ?? true);
        setSearch_btn_ads(data?.search_btn_ads || 'FS');
        setRecant_btn_ads(data?.recant_btn_ads || 'FS');

        setSearch_module_status(data?.search_module_status ?? true);

        // iOS Settings
        setSearch_btn_ads_ios(data?.search_btn_ads_ios || 'FS');
        setSearch_module_status_ios(data?.search_module_status_ios ?? true);
        setIntro_number_ios(data?.intro_number_ios || 1);
        setWelcome_btn_ads_ios(data?.welcome_btn_ads_ios || 'FS');
        setIos_shear_url(data?.ios_shear_url || '');
        setRecant_btn_ads_ios(data?.recant_btn_ads_ios || 'FS');

        // Referral Plan Settings
        setRef_plan_status(data?.ref_plan_status ?? false);

      } else {
        toast.error(message);
      }
    } catch (error) {
      navigate('/Error');
    } finally {
      setLoader(false);
    }
  };

  const handleFacebook = async (e) => {
    e.preventDefault();
    const content = `You are about to update Facebook event data. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.setControllerFacebook({ facebook_app_id, facebook_client_token });
      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Facebook Data');
    } finally {
      setLoader(false);
    }
  };

  const handleRazorpay = async (e) => {
    e.preventDefault();
    if (!razorpay_id.trim()) {
      return toast.error('Razorpay ID cannot be empty', { autoClose: 2000 });
    }
    const content = `You are about to update Razorpay settings. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });
    setLoader(true);
    try {
      const resp = await Calling.setControleUpdate({ name: 'razorpay_id', status: razorpay_id });
      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Razorpay Data');
    } finally {
      setLoader(false);
    }
  };

  const handleAppVersion = async (e) => {
    e.preventDefault();

    if (!app_version.trim()) {
      return toast.error('Application Version cannot be empty', { autoClose: 2000 });
    }

    const content = `You are about to update Application Version. To confirm, please solve this math problem`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);
    try {
      const resp = await Calling.setControleUpdate({
        name: 'app_version',
        status: app_version,
      });
      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update App Version Number');
    } finally {
      setLoader(false);
    }
  };

  const handleCheckboxChange = async (name, value, setterFn) => {
    const content = `You are about to update. To confirm, please solve this math problem.`;
    const isCaptchaValid = generateCaptcha(content);

    if (!isCaptchaValid) {
      return toast.error('Captcha answer is not correct', { autoClose: 2000 });
    }

    setLoader(true);

    try {
      const resp = await Calling.setControleUpdate({ name: name, status: !value });

      if (resp?.status) {
        toast.success('Updated successfully');
        if (setterFn) setterFn(!value);
      } else {
        toast.error(resp.message || 'Failed to update');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to update');
      navigate('/Error');
    } finally {
      setLoader(false);
      fetchData();
    }
  };

  const handleShowWord = async (e) => {
    e.preventDefault();

    if (!show_word.toString().trim() || isNaN(show_word)) {
      return toast.error('Show Word must be a valid number', { autoClose: 2000 });
    }

    const content = `You are about to update Show Word Number. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);

    try {
      const resp = await Calling.setControleUpdate({
        name: 'show_word',
        status: Number(show_word)
      });

      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Show Word');
    } finally {
      setLoader(false);
    }
  };

  const handleSearchLimit = async (e) => {
    e.preventDefault();

    if (!search_limit.toString().trim() || isNaN(search_limit) || search_limit < 1) {
      return toast.error('Search Limit must be a valid number greater than 0', { autoClose: 2000 });
    }

    const content = `You are about to update Search Limit. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);

    try {
      const resp = await Calling.setControleUpdate({
        name: 'search_limit',
        status: Number(search_limit)
      });

      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Search Limit');
    } finally {
      setLoader(false);
    }
  };

  const handleMaskingSearch = async (e) => {
    e.preventDefault();

    if (!masking_search.toString().trim() || isNaN(masking_search) || masking_search < 1) {
      return toast.error('Masking Search must be a valid number greater than 0', { autoClose: 2000 });
    }

    const content = `You are about to update Masking Search. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);

    try {
      const resp = await Calling.setControleUpdate({
        name: 'masking_search',
        status: Number(masking_search)
      });

      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Masking Search');
    } finally {
      setLoader(false);
    }
  };

  const handleMaskingDailog = async (e) => {
    e.preventDefault();

    if (!masking_dailog.toString().trim() || isNaN(masking_dailog) || masking_dailog < 1) {
      return toast.error('Masking Dialog must be a valid number greater than 0', { autoClose: 2000 });
    }

    const content = `You are about to update Masking Dialog. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);

    try {
      const resp = await Calling.setControleUpdate({
        name: 'masking_dailog',
        status: Number(masking_dailog)
      });

      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update Masking Dialog');
    } finally {
      setLoader(false);
    }
  };

  const handleIosShearUrl = async (e) => {
    e.preventDefault();

    const content = `You are about to update iOS Share URL. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);

    try {
      const resp = await Calling.setControleUpdate({
        name: 'ios_shear_url',
        status: ios_shear_url
      });

      if (resp?.status) toast.success(resp?.message);
      else toast.error(resp?.message);
    } catch {
      toast.error('Failed to update iOS Share URL');
    } finally {
      setLoader(false);
    }
  };

  // Search settings configuration
  const searchSettings = [
    { label: 'Mobile Number', value: search_mobile, name: 'search_mobile', setter: setSearch_mobile, icon: <FiPhone size={16} /> },
    { label: 'Name', value: search_name, name: 'search_name', setter: setSearch_name, icon: <FiUser size={16} /> },
    { label: 'Father Name', value: search_fname, name: 'search_fname', setter: setSearch_fname, icon: <FiUsers size={16} /> },
    { label: 'Address', value: search_address, name: 'search_address', setter: setSearch_address, icon: <FiMapPin size={16} /> },
    { label: 'Alt Mobile', value: search_alt_mobile, name: 'search_alt_mobile', setter: setSearch_alt_mobile, icon: <FiPhone size={16} /> },
    { label: 'Circle', value: search_circle, name: 'search_circle', setter: setSearch_circle, icon: <FiGlobe size={16} /> },
    { label: 'ID Number', value: search_id_number, name: 'search_id_number', setter: setSearch_id_number, icon: <FiCreditCard size={16} /> },
    { label: 'Email', value: search_email, name: 'search_email', setter: setSearch_email, icon: <FiMail size={16} /> },
    { label: 'Sub Name', value: search_sub_name, name: 'search_sub_name', setter: setSearch_sub_name, icon: <FiUser size={16} /> },
  ];

  const adOptions = [
    { value: 'FS', label: 'Full Screen' },
    { value: 'RWD', label: 'Rewarded' },
    { value: 'RWD_FS', label: 'Rewarded FS' },
    { value: 'OFF', label: 'Off' },
  ];

  const iosWelcomeOptions = [
    { value: 'FS', label: 'Full Screen' },
    { value: 'OPEN', label: 'Open App' },
    { value: 'RWD_FS', label: 'Rewarded FS' },
    { value: 'OFF', label: 'Off' },
  ];

  const handleAdTypeChange = async (name, newValue, setter) => {
    const content = `You are about to change ad settings. To confirm, please solve this math problem.`;
    const check = generateCaptcha(content);
    if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });

    setLoader(true);
    try {
      const resp = await Calling.setControleUpdate({ name, status: newValue });
      if (resp?.status) {
        toast.success('Updated successfully');
        setter(newValue);
      } else {
        toast.error(resp?.message || 'Failed to update');
      }
    } catch {
      toast.error('Failed to update');
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="w-full min-h-screen">
          {/* Page Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Controller</h1>
            <p className="text-sm text-gray-500 mt-1">Manage app settings and configurations</p>
          </div>

          <div className="space-y-6">
            {/* Quick Toggles Section */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <SectionHeader
                icon={<FiSettings size={20} />}
                title="Quick Toggles"
                action={
                  <button
                    onClick={() => navigate('/manage/ads/txt')}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-main-blue bg-main-blue/10 rounded-xl hover:bg-main-blue/20 transition-colors"
                  >
                    Manage Ads.txt
                    <FiChevronRight size={16} />
                  </button>
                }
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                {[
                  { label: 'InHouse Ads', value: inHouseAds, handler: () => handleCheckboxChange('inHouseAds', inHouseAds, setInHouseAds), icon: <SiGoogleads size={18} /> },
                  { label: 'Search Status', value: search_module_status, handler: () => handleCheckboxChange('search_module_status', search_module_status, setSearch_module_status), icon: <FiSearch size={18} /> },
                  { label: 'Plan Status', value: plan_status, handler: () => handleCheckboxChange('plan_status', plan_status, setPlan_status), icon: <FiSettings size={18} /> },
                  { label: 'Referral Plan', value: ref_plan_status, handler: () => handleCheckboxChange('ref_plan_status', ref_plan_status, setRef_plan_status), icon: <PiHandCoinsFill size={18} /> },
                ].map((item, index) => (
                  <SettingCard key={index} icon={item.icon} label={item.label} highlighted={item.value}>
                    <ToggleSwitch checked={item.value} onChange={item.handler} />
                  </SettingCard>
                ))}
              </div>

              {/* Numeric Settings */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <SettingCard icon={<FiHash size={18} />} label="Search Limit" description="Free user limit">
                  <InputWithSave
                    type="number"
                    value={search_limit}
                    onChange={(e) => setSearch_limit(parseInt(e.target.value) || 0)}
                    onSave={handleSearchLimit}
                    min="1"
                  />
                </SettingCard>

                <SettingCard icon={<FiHash size={18} />} label="Masking Search" description="Search masking limit">
                  <InputWithSave
                    type="number"
                    value={masking_search}
                    onChange={(e) => setMasking_search(parseInt(e.target.value) || 0)}
                    onSave={handleMaskingSearch}
                    min="1"
                  />
                </SettingCard>

                <SettingCard icon={<FiHash size={18} />} label="Masking Dialog" description="Dialog masking limit">
                  <InputWithSave
                    type="number"
                    value={masking_dailog}
                    onChange={(e) => setMasking_dailog(parseInt(e.target.value) || 0)}
                    onSave={handleMaskingDailog}
                    min="1"
                  />
                </SettingCard>
              </div>
            </div>

            {/* User Search Settings */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <SectionHeader
                icon={<FiSearch size={20} />}
                title="User Search Settings"
                action={
                  <div className="flex gap-2">
                    <button
                      onClick={async () => {
                        const content = `Enable all search fields? Solve this math problem.`;
                        const check = generateCaptcha(content);
                        if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });
                        setLoader(true);
                        try {
                          const promises = searchSettings.map(item =>
                            Calling.setControleUpdate({ name: item.name, status: true })
                          );
                          await Promise.all(promises);
                          toast.success('All fields enabled');
                          fetchData();
                        } catch {
                          toast.error('Failed to enable all fields');
                        } finally {
                          setLoader(false);
                        }
                      }}
                      className="px-3 py-1.5 text-xs font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
                    >
                      Enable All
                    </button>
                    <button
                      onClick={async () => {
                        const content = `Disable all search fields? Solve this math problem.`;
                        const check = generateCaptcha(content);
                        if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });
                        setLoader(true);
                        try {
                          const promises = searchSettings.map(item =>
                            Calling.setControleUpdate({ name: item.name, status: false })
                          );
                          await Promise.all(promises);
                          toast.success('All fields disabled');
                          fetchData();
                        } catch {
                          toast.error('Failed to disable all fields');
                        } finally {
                          setLoader(false);
                        }
                      }}
                      className="px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                    >
                      Disable All
                    </button>
                  </div>
                }
              />

              <p className="text-sm text-gray-500 mt-4 mb-4">
                Control which fields appear in mobile number search results
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {searchSettings.map((item, index) => (
                  <SettingCard key={index} icon={item.icon} label={item.label} highlighted={item.value}>
                    <ToggleSwitch
                      checked={item.value}
                      onChange={() => handleCheckboxChange(item.name, item.value, item.setter)}
                      size="small"
                    />
                  </SettingCard>
                ))}
              </div>

              {/* Ad Type Selectors */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                <SettingCard icon={<SiGoogleads size={18} />} label="Search Button Ads" description="Ad on search click">
                  <SelectDropdown
                    value={search_btn_ads}
                    onChange={(e) => handleAdTypeChange('search_btn_ads', e.target.value, setSearch_btn_ads)}
                    options={adOptions}
                  />
                </SettingCard>

                <SettingCard icon={<SiGoogleads size={18} />} label="Recent Button Ads" description="Ad on recent click">
                  <SelectDropdown
                    value={recant_btn_ads}
                    onChange={(e) => handleAdTypeChange('recant_btn_ads', e.target.value, setRecant_btn_ads)}
                    options={adOptions}
                  />
                </SettingCard>
              </div>
            </div>

            {/* iOS Settings */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <SectionHeader
                icon={<MdOutlineInstallMobile size={20} />}
                title="iOS Settings"
              />

              <div className="space-y-4 mt-6">
                <SettingCard icon={<FiSearch size={18} />} label="Search Module Status" description="Enable search on iOS" highlighted={search_module_status_ios}>
                  <ToggleSwitch
                    checked={search_module_status_ios}
                    onChange={() => handleCheckboxChange('search_module_status_ios', search_module_status_ios, setSearch_module_status_ios)}
                  />
                </SettingCard>

                {/* iOS Share URL */}
                <div className="p-4 rounded-2xl border border-gray-100 bg-gradient-to-br from-cyan-50/50 to-transparent">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 rounded-lg bg-cyan-100 text-cyan-600">
                      <FiShare2 size={18} />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-800 text-sm">iOS Share URL</h3>
                      <p className="text-xs text-gray-400">App Store URL for sharing</p>
                    </div>
                  </div>
                  <form onSubmit={handleIosShearUrl} className="flex gap-2">
                    <input
                      type="text"
                      value={ios_shear_url}
                      onChange={(e) => setIos_shear_url(e.target.value)}
                      className="flex-1 px-4 py-2 text-sm border border-gray-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
                      placeholder="https://apps.apple.com/app/your-app-id"
                    />
                    <button
                      type="submit"
                      className="px-4 py-2 bg-main-blue text-white text-sm font-medium rounded-xl hover:bg-main-blue/90 transition-colors"
                    >
                      Save
                    </button>
                  </form>
                </div>

                {/* iOS Numeric & Select Settings */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <SettingCard icon={<MdTextDecrease size={18} />} label="Intro Number" description="Intro screens count">
                    <InputWithSave
                      type="number"
                      value={intro_number_ios}
                      onChange={(e) => setIntro_number_ios(parseInt(e.target.value) || 0)}
                      onSave={async () => {
                        const content = `Update Intro Number for iOS? Solve this math problem.`;
                        const check = generateCaptcha(content);
                        if (!check) return toast.error('Answer is not correct', { autoClose: 2000 });
                        setLoader(true);
                        try {
                          const resp = await Calling.setControleUpdate({ name: 'intro_number_ios', status: intro_number_ios });
                          if (resp?.status) toast.success('Updated successfully');
                          else toast.error(resp?.message || 'Failed to update');
                        } catch {
                          toast.error('Failed to update');
                        } finally {
                          setLoader(false);
                        }
                      }}
                      min="0"
                    />
                  </SettingCard>

                  <SettingCard icon={<SiGoogleads size={18} />} label="Welcome Ads" description="Welcome screen ad type">
                    <SelectDropdown
                      value={welcome_btn_ads_ios}
                      onChange={(e) => handleAdTypeChange('welcome_btn_ads_ios', e.target.value, setWelcome_btn_ads_ios)}
                      options={iosWelcomeOptions}
                    />
                  </SettingCard>

                  <SettingCard icon={<SiGoogleads size={18} />} label="Search Button Ads" description="Search ad type on iOS">
                    <SelectDropdown
                      value={search_btn_ads_ios}
                      onChange={(e) => handleAdTypeChange('search_btn_ads_ios', e.target.value, setSearch_btn_ads_ios)}
                      options={adOptions}
                    />
                  </SettingCard>

                  <SettingCard icon={<SiGoogleads size={18} />} label="Recent Button Ads" description="Recent ad type on iOS">
                    <SelectDropdown
                      value={recant_btn_ads_ios}
                      onChange={(e) => handleAdTypeChange('recant_btn_ads_ios', e.target.value, setRecant_btn_ads_ios)}
                      options={adOptions}
                    />
                  </SettingCard>
                </div>
              </div>
            </div>

            {/* Configuration Cards Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Show Word */}
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                <SectionHeader icon={<MdTextDecrease size={20} />} title="Show Word" />
                <form onSubmit={handleShowWord} className="mt-6">
                  <label className="block text-sm font-medium text-gray-600 mb-2">Word Display Count</label>
                  <div className="flex gap-3">
                    <input
                      type="number"
                      value={show_word}
                      onChange={(e) => setShow_word(e.target.value)}
                      className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
                      placeholder="e.g. 5"
                    />
                    <button
                      type="submit"
                      className="px-6 py-2.5 bg-main-blue text-white font-medium rounded-xl hover:bg-main-blue/90 transition-colors"
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>

              {/* App Version */}
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
                <SectionHeader icon={<MdOutlineInstallMobile size={20} />} title="App Version" />
                <form onSubmit={handleAppVersion} className="mt-6">
                  <label className="block text-sm font-medium text-gray-600 mb-2">Application Version</label>
                  <div className="flex gap-3">
                    <input
                      type="text"
                      value={app_version}
                      onChange={(e) => setApp_version(e.target.value)}
                      className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
                      placeholder="e.g. 1.8.5"
                    />
                    <button
                      type="submit"
                      className="px-6 py-2.5 bg-main-blue text-white font-medium rounded-xl hover:bg-main-blue/90 transition-colors"
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* Facebook Settings */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <SectionHeader icon={<FaFacebookSquare size={20} className="text-blue-600" />} title="Facebook Integration" />
              <form onSubmit={handleFacebook} className="mt-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-2">Facebook App ID</label>
                  <input
                    type="text"
                    value={facebook_app_id}
                    onChange={(e) => setFacebook_app_id(e.target.value)}
                    className="w-full px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
                    placeholder="e.g. 135885938132XXXX"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-2">Facebook Client Token</label>
                  <input
                    type="text"
                    value={facebook_client_token}
                    onChange={(e) => setFacebook_client_token(e.target.value)}
                    className="w-full px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
                    placeholder="e.g. 964343XX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
                  />
                </div>
                <div className="flex justify-end pt-2">
                  <button
                    type="submit"
                    className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-xl hover:bg-blue-700 transition-colors"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>

            {/* Razorpay Settings */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <SectionHeader icon={<SiRazorpay size={20} className="text-blue-600" />} title="Razorpay Integration" />
              <form onSubmit={handleRazorpay} className="mt-6">
                <label className="block text-sm font-medium text-gray-600 mb-2">Razorpay ID</label>
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={razorpay_id}
                    onChange={(e) => setRazorpay_id(e.target.value)}
                    className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue/30 transition-all"
                    placeholder="e.g. rzp_live_XXXXXXXXXX"
                  />
                  <button
                    type="submit"
                    className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-xl hover:bg-blue-700 transition-colors"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Controler;